import { c as _c } from "react/compiler-runtime";
import { useLocale } from 'next-intl';
import { Button, type ButtonProps } from 'ui';
import { getProductFromRequestSource } from 'utils/requestSource/requestSource';
import { getLovableUrlForBlueprint } from '~/constants';
import { OVERVIEW_EXPERIMENT_ID, OVERVIEW_EXPERIMENT_LP_SLUG } from '~/constants/overviewExperiment';
import useJourneyData from '~/hooks/useJourneyData';
import { getPathname } from '~/i18n/navigation';
import { api } from '~/libs/api';
import { useIsCheckingAvailability, useJourneyActions } from '~/stores/journeyStore';
export function BookButton(props) {
  const $ = _c(23);
  const sendEvent = api.facebook.sendEvent.useMutation();
  const {
    bookingInformation,
    user,
    source
  } = useJourneyData();
  const {
    setIsCheckingAvailability
  } = useJourneyActions();
  const isCheckingAvailability = useIsCheckingAvailability();
  const locale = useLocale();
  const isBookedTrip = bookingInformation?.bookingStatus === "BOOKED" || bookingInformation?.bookingStatus === "OUTSTANDING";
  const isDisabled = props.disabled || isBookedTrip;
  const t0 = user.requestSource?.name ?? "";
  let t1;
  if ($[0] !== t0) {
    t1 = getProductFromRequestSource(t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const product = t1;
  const lp = user.requestSource?.modifier && user.requestSource.modifier !== "default" ? user.requestSource.modifier : undefined;
  const blueprintId = source?.originalBlueprintId ?? undefined;
  const isExperimentConversion = lp === OVERVIEW_EXPERIMENT_LP_SLUG && blueprintId !== undefined && getLovableUrlForBlueprint(blueprintId) !== undefined;
  if (isDisabled) {
    const t2 = props.size || "medium";
    const t3 = `disabled-book-button-${product}`;
    let t4;
    if ($[2] !== isCheckingAvailability || $[3] !== props.children || $[4] !== t2 || $[5] !== t3) {
      t4 = <Button size={t2} className="pointer-events-none" disabled={true} loading={isCheckingAvailability} data-ua-click={t3}>{props.children}</Button>;
      $[2] = isCheckingAvailability;
      $[3] = props.children;
      $[4] = t2;
      $[5] = t3;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    return t4;
  }
  let t2;
  if ($[7] !== locale || $[8] !== props.href) {
    t2 = props.href ? getPathname({
      href: props.href,
      locale
    }) : props.href;
    $[7] = locale;
    $[8] = props.href;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== sendEvent || $[11] !== setIsCheckingAvailability) {
    t3 = () => {
      setIsCheckingAvailability(true);
      ;
      try {
        sendEvent.mutate({
          eventName: "InitiateCheckout"
        });
      } catch (t4) {
        const _error = t4;
      }
    };
    $[10] = sendEvent;
    $[11] = setIsCheckingAvailability;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const t4 = `book-button-${product}`;
  const t5 = `book-button-${product}`;
  const t6 = isExperimentConversion ? OVERVIEW_EXPERIMENT_ID : undefined;
  let t7;
  if ($[13] !== blueprintId || $[14] !== isCheckingAvailability || $[15] !== lp || $[16] !== props || $[17] !== t2 || $[18] !== t3 || $[19] !== t4 || $[20] !== t5 || $[21] !== t6) {
    t7 = <Button {...props} is="a" href={t2} onClick={t3} data-ua-click={t4} data-testid={t5} data-lp-source={lp} data-blueprint-id={blueprintId} data-experiment-conversion={t6} loading={isCheckingAvailability}>{props.children}</Button>;
    $[13] = blueprintId;
    $[14] = isCheckingAvailability;
    $[15] = lp;
    $[16] = props;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
}